import Content from "../../Components/Content/Content";
import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ErrorModal from "../../Components/Modals/ErrorModal";
import { UserFeaturesParams } from "../../Functions/UserManagement/UserManagement";
import LicenseGrid from "../../Components/LicenseGrid/LicenseGrid";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import CustomerContent from "../../Components/Content/CustomerContent";

const UserManagement: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string>("licenses");

  const [errorVisible, setErrorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const userData = useSelector((state: RootState) => state.user.user);

  const [filterData, setFilterData] = useState<UserFeaturesParams>();

  const handleTabSelect = (key: any) => {
    setActiveKey(key);
  };

  const handleCloseError = () => {
    setErrorVisible(false);
  };

  return (
    <>
      <Content>
        <div className={"row p-0 m-0"}>
          <div className={"col-12 p-0"}>
            <Tabs
              id="voicemail-tabs"
              activeKey={activeKey}
              onSelect={handleTabSelect}
              className="mb-3 font-14"
              defaultActiveKey="inbox"
            >
              <Tab eventKey="licenses" title="Licenses" tabClassName={`tabs`}>
                {userData?.custID ? (
                  <LicenseGrid />
                ) : (
                  <CustomerContent />
                )}
              </Tab>
              {/*<Tab
                eventKey="userFeatures"
                title="User Features"
                tabClassName={`tabs`}
              >
                {userData?.custID ? (
                  <UserFeaturesTable
                    setFilterData={setFilterData}
                    filterData={filterData}
                    custId={userData?.custID}
                  />
                ) : (
                  <CustomerContent />
                )}
              </Tab>*/}
            </Tabs>
          </div>
        </div>
        <ErrorModal
          visible={errorVisible}
          errorMessage={errorMessage}
          onClose={handleCloseError}
        />
      </Content>
    </>
  );
};

export default UserManagement;
